export default {"en-US": __webpack_public_path__ + "i18n/en-US.b5fcc002.i18next.json"};